function resolveApiBase(): string {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname.toLowerCase();
    if (host.endsWith('.boox.app') || host.endsWith('.boox.network')) {
      return '';
    }
  }
  if (typeof import.meta !== 'undefined' && (import.meta.env as Record<string, string>).VITE_API_BASE_URL) {
    return (import.meta.env as Record<string, string>).VITE_API_BASE_URL;
  }
  return '';
}

export const API_BASE = resolveApiBase();
